import useUpdateViewerPageState from '../../../../..//hooks/useUpdateViewerPageState';
import { GOOGLE_EVENT_ID } from '../../../../../constant/googleEventId';
import { HyperLinkType } from '../../../../PdfViewer/index.types';
import { isDeviceLink } from '../../../../../utils/hyperLink';
import useHandleHyperLinkClick from '../../../../../hooks/useHandleHyperLinkClick';

import * as Styled from './index.styles';

interface Props {
  hyperlinkList: HyperLinkType[];
  resizedImageSize: {
    heightRatio: number;
    widthRatio: number;
    xMargin: number;
    yMargin: number;
  };
  isPreview: boolean;
  getFormNotSubmitPage?: (page: number) => number | null;
}

const DesktopHyperLinkLayer = ({
  hyperlinkList,
  resizedImageSize,
  isPreview,
  getFormNotSubmitPage,
}: Props) => {
  const { handleUserHyperLinkClick } = useHandleHyperLinkClick();
  const { updateCurrentPage } = useUpdateViewerPageState();

  if (hyperlinkList.length === 0) {
    return null;
  }
  return (
    <>
      {hyperlinkList.map(
        ({ id, rect_x1, rect_x2, rect_y1, rect_y2, type, url, pageNumber }) => {
          const bottom =
            rect_y1 * resizedImageSize.heightRatio + resizedImageSize.yMargin;
          const left =
            rect_x1 * resizedImageSize.widthRatio + resizedImageSize.xMargin;
          const width =
            rect_x2 * resizedImageSize.widthRatio -
            rect_x1 * resizedImageSize.widthRatio;
          const height =
            rect_y2 * resizedImageSize.heightRatio -
            rect_y1 * resizedImageSize.heightRatio;
          return (
            <Styled.LinkWrapper
              id={GOOGLE_EVENT_ID.hyperLink}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (!isPreview) {
                  handleUserHyperLinkClick(id);
                }

                if (type === 'page' && pageNumber) {
                  updateCurrentPage(pageNumber);

                  if (getFormNotSubmitPage) {
                    const notSubmitPage = getFormNotSubmitPage(
                      Number(pageNumber),
                    );
                    if (notSubmitPage !== null) {
                      updateCurrentPage(notSubmitPage);
                      return;
                    }
                  }

                  updateCurrentPage(pageNumber);
                  return;
                }

                if (!url) {
                  return;
                }

                if (isDeviceLink(type, url)) {
                  window.location.href = url;
                  return;
                }

                if (window) {
                  window.open(url, '_blank');
                }
              }}
              key={id}
              style={{
                bottom: `${bottom}px`,
                left: `${left}px`,
                width: `${width}px`,
                height: `${height}px`,
              }}
            />
          );
        },
      )}
    </>
  );
};

export default DesktopHyperLinkLayer;
